module.exports = __webpack_public_path__ + "static/media/CTLA_11-286w.449a0011.webp";